import { createRouter, createWebHistory } from "vue-router";

const routes = [
  { path: "/", name: "Home", component: () => import("./components/Hero.vue") },
  { path: "/about", name: "About", component: () => import("./components/About.vue") },
  { path: "/products", name: "Products", component: () => import("./components/Products.vue") },
  { path: "/partners", name: "Partners", component: () => import("./components/Partners.vue") },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
